export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-dialog/index.js